import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MenuService } from '../services/menu.service';

@Component({
    selector: 'ez-menu',
    template: '',
})
export class MenuComponent {

    constructor(
        private router: Router,
        private location: Location,
        protected menuService: MenuService
    ) {

    }

    public select(item) {
        if (item.link !== '') {
            this.router.navigate([item.link]);
        } else if (item.type === 'back') {
            this.location.back();
        } else if (item.type === 'callback') {
            item.triggerCallback();
        }
        this.menuService.selectMenu(item);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/menu.component.ts